import { getRequestProps } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { stringifyUrl } from "query-string";
export function YourBetRequestFormatter(message) {
    const { baseUrl, endpoint, method, headers, params } = getRequestProps(ConnectionNames.yourBet, message);
    headers["Content-Type"] = "application/json; charset=utf-8";
    const query = stringifyUrl({
        url: `${baseUrl}${endpoint}`,
        query: params
    }, {
        skipNull: true,
        arrayFormat: "comma",
        sort: false
    });
    return new Request(query, {
        method,
        headers
    });
}
//# sourceMappingURL=YourBetRequestFormatter.js.map